
import {
  defineComponent,
  ref,
  computed,
  useContext,
  useFetch,
  useStore,
  useMeta,
} from '@nuxtjs/composition-api';
import { useFetchCategory } from '@/composables';

export default defineComponent({
  setup() {
    const { route, error } = useContext();
    const store = useStore();
    const currentPage = computed(() => route.value.query.page);
    const filter = computed(() => route.value.query.categories);
    const featuresFilters = computed(() => route.value.query.features);
    const categorySlug = route.value.params.category;
    const subCategorySlug = route.value.params.subcategory;
    const subSubCategorySlug = route.value.params.subsubcategory;

    const allCategories = ref(store.getters['categories/getAllCategories']);
    const category = computed(() => {
      return allCategories.value.find((c) => {
        return c.slug === categorySlug;
      });
    });
    const subCategory = computed(() => {
      return category.value?.children?.find((c) => {
        return c.slug === subCategorySlug;
      });
    });
    const subSubCategory = computed(() => {
      return subCategory.value?.children?.find((c) => {
        return c.slug === subSubCategorySlug;
      });
    });
    const isSubCategoriesEmpty = computed(
      () => !subCategory.value || !subSubCategory.value,
    );

    if (!subSubCategory.value) error({ statusCode: 404 });
    else
      useMeta(() => ({
        title: subSubCategory?.value.seo?.page_title,
        meta: [
          {
            name: 'description',
            hid: 'description',
            content: subSubCategory?.value.seo?.description,
          },
          {
            property: 'og:title',
            hid: 'og:title',
            content: subSubCategory?.value.seo?.og_title,
          },
        ],
      }));

    const {
      totalPages,
      products,
      loading: loadingProducts,
      fetchCategoryBySlug,
      category: categoryData,
    } = useFetchCategory();
    const tipsSection = computed(() =>
      categoryData.value?.contents?.find(
        (section) => section.type === 'tips-section',
      ),
    );

    useFetch(async () => {
      await fetchCategoryBySlug({
        slug: subSubCategorySlug,
        page: currentPage.value,
        categories: filter.value
          ?.slice()
          .split(',')
          .map((i) => Number(i)),
        features: featuresFilters.value
          ?.slice()
          .split(',')
          .map((i) => Number(i)),
      });
    });

    const handleChange = ({ categories, features, page }) => {
      fetchCategoryBySlug({
        slug: subSubCategorySlug,
        page,
        categories,
        features,
      });
    };

    return {
      category,
      subCategory,
      subSubCategory,
      totalPages,
      products,
      loadingProducts,
      handleChange,
      tipsSection,
      isSubCategoriesEmpty,
      categoryData,
    };
  },
  head: {},
});
